'use client';

import { Dialog, DialogContent } from '@mui/material';
import { MediaBrowserV2Provider } from '@/app/features/shared/media-browser-v2/context/MediaBrowserV2Context';
import { MediaType } from '@/app/features/shared/media-browser-v2/types/types';
import MediaBrowserV2 from './MediaBrowserV2';
import { UploadFile } from '@/app/lib/generated/graphql-types';

type MediaBrowserV2DialogProps = {
    isOpen: boolean;
    onApply: (media: UploadFile | null) => void;
    onClose: () => void;
    initialMediaTypes?: MediaType[];
};

export default function MediaBrowserV2Dialog({
    isOpen,
    onApply,
    onClose,
    initialMediaTypes,
}: MediaBrowserV2DialogProps) {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            fullWidth
            maxWidth={false}
            PaperProps={{
                sx: {
                    width: '95vw',
                    height: '95vh',
                    maxWidth: 'none',
                    maxHeight: 'none',
                    m: 0,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    overscrollBehavior: 'contain',
                    backdropFilter: 'none',
                    WebkitBackdropFilter: 'none',
                }
            }}
        >
            <DialogContent
                sx={{
                    p: 0,
                    overflow: 'hidden',
                    display: 'flex',
                    flex: 1,
                    '&.MuiDialogContent-root': {
                        padding: 0,
                    }
                }}
            >
                <MediaBrowserV2Provider
                    key={initialMediaTypes?.join(',') ?? 'all-media-types'}
                    mode="picker"
                    onApply={onApply}
                    onClose={onClose}
                    initialMediaTypes={initialMediaTypes}
                    persistState={true}
                >
                    <MediaBrowserV2 />
                </MediaBrowserV2Provider>
            </DialogContent>
        </Dialog>
    );
}
